<template>
  <div class="bulk-tags-wrapper" v-show='opened'>
    <form>
      <div class="search-wrapper">
        <input v-model='q' @keydown.enter='addTag()' type='text' :placeholder='qPlaceholder' class='form-control' />
      </div>

      <div class="selectable-tags-wrapper" v-scroll='scroll'>
        <div v-if="q.length > 0 && !loading && !isExactMatch" @click="addTag()" class="selectable-tag">
          <b><i class="fa fa-plus"></i> {{ $t('tags_manager.create_tag') }}:</b> {{ q }}
        </div>

        <div v-for="tag in orderedTags" @click="toggleTag(tag) " :class="[{ 'selected': selectedTags[tag.id] }, 'selectable-tag']">
          <i class="fa fa-tag"></i>
          {{ tag.name }}
        </div>

        <div v-show='loading'>
          {{ $t('shared.loading') }}
        </div>
      </div>

      <div @click="submit" class="btn btn-primary btn-sm">
        {{ $t('products.list.submit') }}
      </div>

      <div @click='opened = false' class="btn btn-outline-primary btn-sm">
        {{ $t('products.list.cancel') }}
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        q: '',
        tags: [],
        sentEmailsIds: [],
        futureEmailsIds: [],
        receivedEmailsIds: [],
        automatedEmailIds: [],
        recordMessageIds: [],
        selectedTags: {},
        loading: true,
        opened: false,
        page: 0,
      }
    },
    created() {
      this.debouncedLoadMoreOptions = this._debounce(() => this.loadMoreOptions(), 500)
    },
    watch: {
      q() {
        this.page = 0
        this.tags = []
        this.loading = true
        this.noMoreResults = false
        this.debouncedLoadMoreOptions()
      }
    },
    computed: {
      qPlaceholder() {
        return this.tags.length > 0 ? this.$t('tags_manager.search_tag') : this.$t('tags_manager.create_a_tag')
      },
      isExactMatch() {
        return this.tags.some(t => t.name.toLowerCase() == this.q.toLowerCase())
      },
      orderedTags() {
        return this.tags.slice().sort((a, b) => {
          return this.selectedTags[a.id] && this.selectedTags[b.id] ? -1 : a.name.localeCompare(b.name)
        })
      }
    },
    methods: {
      open(sentEmailsIds, futureEmailsIds, receivedEmailsIds, automatedEmailIds, recordMessageIds) {
        this.sentEmailsIds = sentEmailsIds || []
        this.futureEmailsIds = futureEmailsIds || []
        this.receivedEmailsIds = receivedEmailsIds || []
        this.automatedEmailIds = automatedEmailIds || []
        this.recordMessageIds = recordMessageIds || []
        this.selectedTags = {}
        this.opened = true
        this.loadMoreOptions()
      },
      close() {
        this.opened = false
      },
      addTag() {
        this.store.createTag({ name: this.q }).then(({data}) => {
          this.q = ''
          this.loadTags()
          this.toggleTag(data)
          this.$toastr.success(this.$t('products.list.tag_created'))
        })
      },
      toggleTag(tag) {
        if (this.selectedTags[tag.id])
          return this.$delete(this.selectedTags, tag.id)
        this.selectedTags = Object.assign({}, this.selectedTags, { [tag.id]: tag })
      },
      submit(e) {
        const params = { tag_ids: Object.keys(this.selectedTags) }

        let sentEmailPromise = null
        let futureEmailPromise = null
        let receivedEmailPromise = null
        let automatedEmailPromise = null
        let recordMessagePromise = null

        if (this.sentEmailsIds.length > 0) {
          sentEmailPromise = this.axios.post("/connected_tags/", Object.assign({}, params, {document_request_ids: this.sentEmailsIds}))
        }
        if (this.futureEmailsIds.length > 0) {
          futureEmailPromise = this.axios.post("/connected_tags/", Object.assign({}, params, {document_request_ids: this.futureEmailsIds}))
        }
        if (this.receivedEmailsIds.length > 0) {
          receivedEmailPromise = this.axios.post("/connected_tags/", Object.assign({}, params, {document_response_ids: this.receivedEmailsIds}))
        }
        if (this.automatedEmailIds.length > 0) {
          automatedEmailPromise = this.axios.post("/connected_tags/", Object.assign({}, params, {automated_email_ids: this.automatedEmailIds}))
        }
        if (this.recordMessageIds.length > 0) {
          recordMessagePromise = this.axios.post("/connected_tags/", Object.assign({}, params, {record_message_ids: this.recordMessageIds}))
        }

        Promise.allSettled([sentEmailPromise, futureEmailPromise, receivedEmailPromise, automatedEmailPromise, recordMessagePromise]).then(() => {
          this.store.sendMetrics({name: 'bulk_connect_tag_with_resource', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.close()
        })
      },
      loadMoreOptions() {
        this.loading = true

        this.listStore.getTags({ q: this.q, page: this.page + 1 }).then((data) => {
          this.loading = false
          this.page = data.meta.page

          if (data.data.length > 0)
            this.tags = this.tags.concat(data.data)
          else
            this.noMoreResults = true
        })
      },
      scroll(e) {
        if (this.loading || this.noMoreResults)
          return

        if (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight) > 0.8) {
          this.loadMoreOptions()
        }
      },
    }
  }
</script>

<style lang="sass" scoped>
  form
    position: absolute
    top: 46px
    right: 0
    background: #ffffff
    width: 250px
    border: 1px solid #c4c4c4
    border-radius: 3px
    padding: 5px
    z-index: 100
    .btn
      margin-top: 15px
      float: right
    .btn-outline-primary
      margin-right: 10px
    .bulk-tags-wrapper
      width: 280px
      position: relative
    .selectable-tags-wrapper
      text-align: left
</style>
